import { combineReducers } from 'redux';

import page from './page';
import events from './events';
import media from './media';
import leaderboard from './leaderboard';
import translations from './translations';
import navigation from './navigation';
import cultures from './cultures';

export default combineReducers({
  page,
  events,
  media,
  leaderboard,
  translations,
  navigation,
  cultures,
});
